import React, { ChangeEvent } from 'react';
import { Modal, Input } from 'antd';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';

import { WhiteButton } from '@components';
import { BlueButton } from '@share/components';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

import './style.scss';

interface IProps extends WrappedComponentProps {
  visible: boolean;
  refundable: boolean;
  cancellationPolicesText: string;
  onCancel: (comment: string) => void;
  onClose: () => void;
}

interface IState {
  note: string;
  error: string;
  isButtonDisabled: boolean;
}

const rows = 5;
const oneHundred = 1000;
const modalWidth = 450;
const { TextArea } = Input;

class CancelModalComponent extends React.Component<IProps, IState> {
  state: IState = {
    note: '',
    error: '',
    isButtonDisabled: false,
  };

  validateNote = () => {
    const { note } = this.state;
    if (!note.trim()) {
      this.setState({ error: 'Comment is required',isButtonDisabled: true  });
      return false;
    }
    if (note.trim().length < 5) {
      this.setState({ error: 'Comment must be at least 5 characters long', isButtonDisabled: true  });
      return false;
    }
    if (note.trim().length > 1000) {
      this.setState({ error: 'Comment must be less than 1000 characters long', isButtonDisabled: true  });
      return false;
    }
    const repeatingCharacters = /(\.{4,})/; 
    if (repeatingCharacters.test(note)) {
      this.setState({ error: 'Comment contains excessive repeating characters', isButtonDisabled: true  });
      return false;
    }
    this.setState({ error: '', isButtonDisabled: false  });
    return true;
  };
  
  onNoteChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({
      note: e.target.value,
      isButtonDisabled: false,
    }, this.validateNote);
  };

  onConfirmCancel = () => {
    if (this.validateNote()) {
      this.props.onCancel(this.state.note);
    }
  };
  handleCancel = () => {
    this.setState({ error: '', note : '', isButtonDisabled: false  });
    this.props.onClose();
  };


  render(): React.ReactNode {
    const { visible, refundable, cancellationPolicesText, onClose, intl } = this.props;
    const { note, error, isButtonDisabled } = this.state;
    return (
      <div className="cancel-modal">
        <Modal
          className="cancel-modal-wrapper"
          wrapClassName="cancel-modal-wrapper__wrap"
          visible={visible}
          footer={null}
          onCancel={onClose}
          closable={true}
          destroyOnClose={true}
          closeIcon={<FontAwesomeIcon icon={faTimes} />}
          width={modalWidth}
          title={<FormattedMessage id="mark.as.cancelled" />}
        >
          <div className="cancel-modal-wrapper__error">
            <FontAwesomeIcon icon={faInfoCircle} /> <FormattedMessage id="this.action.cannot.be.undone" />          
          </div>
          <div className="cancel-modal-wrapper__main">   
            <div className="cancel-modal-wrapper__area">
              <strong style={{ marginRight: '5px' }}>Cancellation Policy: </strong>
              {cancellationPolicesText}
            </div>         
            <div className="cancel-modal-wrapper__label">
              <FormattedMessage id="add.note" />
            </div>
            <div className="cancel-modal-wrapper__area">              
              <div className='position-relative'>
                <TextArea
                  showCount={true} 
                  maxLength={oneHundred}
                  value={note}
                  onChange={this.onNoteChange}
                  placeholder={intl.formatMessage({ id: 'enter.text.here' })}
                  rows={rows}
                />
                {error && <span className="text-danger">{error}</span>}
               </div>
            </div>
          </div>
          <div className="cancel-modal-wrapper__footer w-100">
            <WhiteButton onClick={this.handleCancel}>
              <FormattedMessage id="cancel" />
            </WhiteButton>
            <BlueButton onClick={this.onConfirmCancel} disabled={isButtonDisabled}>
              {refundable ? <FormattedMessage id="confirm.and.refund" /> : <FormattedMessage id="confirm.cancellation" />}
            </BlueButton>
          </div>
        </Modal>
      </div>
    );
  }
}

export const CancelModal = injectIntl(CancelModalComponent);
